import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
import { ShinyButton } from "../../../../global-account/react/index.js";
import { getPaymentMethodDescription, getVendorDisplayName } from "../../../../shared/utils/payment.utils.js";
import { ChevronRight } from "lucide-react";
import HowItWorks from "./HowItWorks.js";
export default function PaymentOneClick({ order }) {
    const vendor = order.onrampMetadata?.vendor;
    const vendorName = getVendorDisplayName(vendor);
    const paymentDescription = getPaymentMethodDescription(vendor);
    const howItWorksSteps = [
        {
            number: 1,
            description: `Click the link above to pay with ${paymentDescription}`,
        },
        {
            number: 2,
            description: `After payment, you'll be redirected back here, where we continue to execute the order.`,
        },
    ];
    return (_jsxs("div", { className: "relative my-8 flex w-full flex-1 flex-col items-center justify-center", children: [_jsx("a", { href: order.oneClickBuyUrl || "", target: "_blank", className: "w-4/5", children: _jsx(ShinyButton, { accentColor: "hsl(var(--as-brand))", className: "relative w-full py-6", children: _jsxs("div", { className: "relative z-10 flex items-center justify-center gap-3", children: [_jsxs("span", { className: "text-lg font-medium text-white", children: ["Continue to ", vendorName] }), _jsx(ChevronRight, { className: "h-5 w-5 text-white/90" })] }) }) }), _jsx(HowItWorks, { steps: howItWorksSteps })] }));
}
